/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const getReferralFunnelV1ResponseDataSchema = z.object({
  pending: z.number(),
  activated: z.number(),
  rewarded: z.number(),
  total: z.number(),
});

export type IGetReferralFunnelV1ResponseData = z.infer<
  typeof getReferralFunnelV1ResponseDataSchema
>;

export const getReferralFunnelV1ResponseSchema = createApiResponseSchema(
  getReferralFunnelV1ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetReferralFunnelV1ResponseData>>;

export type IGetReferralFunnelV1Response = IAPI<IGetReferralFunnelV1ResponseData>;
